import { render, staticRenderFns } from "./PDFMaterialSinglePage.vue?vue&type=template&id=dccf41b0&"
import script from "./PDFMaterialSinglePage.vue?vue&type=script&lang=js&"
export * from "./PDFMaterialSinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports